<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.hide()"><span aria-hidden="true">&times;</span></button>
    <h3 class="modal-title">Demonstrativo de resultado (DRE)</h3>
  </div>
  <div class="modal-body">
    <section class="content">
      <div class="info">
        <span class="info-title">Total de Receitas Operacionais
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Total da \"Quantidade vendida\" (*) total do \"Preço unitário de venda\", ambos da tela \"Levantamento das Vendas - Margem Bruta\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.totalReceitasOperacionais | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Total de Despesas Operacionais
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Total da \"Quantidade vendida\" (*) total do \"Custo unitário de compra\", ambos da tela \"Levantamento das Vendas - Margem Bruta\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.totalDespesasOperacionais | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title bold">Resultado Operacional Bruto
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"\"Total de Receitas Operacionais\" (-) \"Total de Despesas Operacionais\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.resultadoOperacionalBruto | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <hr />

      <div class="info">
        <span class="info-title">Despesas Administrativas
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Valor informado no campo \"Despesas Operacionais do Negócio\" na tela \"Dados Financeiros do Empreendimento\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.despesasAdministrativas | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Despesas Financeiras
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Total do \"Valor da parcela mensal\", na tela \"Dados do empreendimento\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.despesasFinanceiras | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title bold">Resultado Líquido do Empreendimento
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"\"Resultado Operacional Bruto\" (-) \"Despesas Administrativas\" (-) \"Despesas Financeiras\" desta tela"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.resultLiqEmpreendimento | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <hr />

      <div class="info">
        <span class="info-title">Outras Receitas Familiares
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Valor do campo \"Soma da renda familiar\", na tela \"Dados Financeiros do Empreendimento\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.outrasReceitasFamilia | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Outras Despesas Familiares
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Somatórias dos campos \"Despesas com alimentação da família\", \"Despesas com aluguel residencial\", \"Despesas com vestuário na família\", \"Despesas com educação na família\", \"Despesas com água, luz, telefone e internet na família\", \"Despesas com prestações de móveis, eletrodomésticos e outros\", todos da tela \"Dados Financeiros do Empreendimento\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.outrasDespesasFamilia | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title bold">Resultado do Empreendimento e Familiar
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"\"Resultado Líquido do Empreendimento\" (+) \"Outras Receitas Familiares\" (-) \"Outras Despesas Familiares\", todos desta tela"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.resultEmpreendimentoFamilia | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <hr />

      <div class="info">
        <span class="info-title">Disponibilidade Mensal com base no Emprendimento
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"\"Resultado Líquido do Empreendimento\" (*) \"Percentual de capacidade de pagamento sobre os valores declarados\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.disponibilidadeMensalEmpreendimento | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Disponibilidade Mensal com base no Empreendimento e Resultado Familiar
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"\"Resultado do Empreendimento e Familiar\" (*) \"Percentual de capacidade de pagamento sobre os valores declarados\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.disponibilidadeMensalEmpreendimentoFamilia | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Endividamento com base no Passivo Declarado
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"(\"Soma valor em caixa e bancos hoje\" (+) \"Contas a receber\" (+) \"Estoque\" (-) \"Dívidas com fornecedores\" (-) \"Contas a pagar em geral\") todos da tela \"Dados Financeiros do Empreendimento\" (*) \"Percentual de capacidade de endividamento sobre os valores declarados\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.endividamentoPassivo | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <hr />

      <div class="info">
        <span class="info-title">Percentual Avaliação Risco Social
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Valor do parâmetro PERCENTUAL TOTAL, da tabela de parâmetros"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.percentualRiscoSocial | number:'1.2-2' }}%</span>
      </div>
      <div class="info">
        <span class="info-title">Valor das Parcelas com base no Empreendimento Declarado
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"\"Disponibilidade Mensal com base no Empreendimento\" (*) \"Percentual Avaliação Risco Social\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.valorParcelaEmpreendimento | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Valor das Parcelas com base no Empreendimento e Familiar Declarados
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"\"Disponibilidade Mensal com base no Resultado do Empreendimento e Resultado Familiar\" (*) \"Percentual Avaliação Risco Social\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model.valorParcelaEmpreendimentoFamilia | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Capacidade do Endividamento
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"(\"Percentual de capacidade de endividamento sobre os valores declarados\" (-) \"Percentual de Endividamento\") (*) \"TOTAL DO ATIVO\" (da tela \"Balanço Patrimonial\")"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.capacidadeEndividamento | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>

    </section>
  </div>
  <div class="modal-footer centered">
    <button class="btn btn-border-orange" (click)="modal.hide()">Fechar</button>
  </div>
</div>
